import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('bringozPackageCustomDataDisplay', bringozPackageCustomDataDisplay);

function bringozPackageCustomDataDisplay() {
  return function bringozPackageCustomDataDisplayFilter(packageItem, packageDynamicColumn) {
    if (!packageItem) {
      return;
    }
    let match = _.find(packageItem.configuredFields || [], (cf) => {
      return cf.id === packageDynamicColumn.id || cf.packageFieldId === packageDynamicColumn.id || cf.fieldName === packageDynamicColumn.title;
    })
    return match?.value || '---';
  }
}
